var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OmitType, PartialType, PickType } from "@nestjs/swagger";
import { BaseOrganizationDto, BaseOrganizationPublicProfileDto } from "./organization.dtos";
import { UserType } from "./user.dtos";
import { IsEnum } from "class-validator";
export class ServiceProviderOrganizationPublicProfileDto extends BaseOrganizationPublicProfileDto {
    constructor(fields) {
        super();
        this.type = UserType.SERVICE_PROVIDER;
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(UserType),
    __metadata("design:type", Object)
], ServiceProviderOrganizationPublicProfileDto.prototype, "type", void 0);
export class ServiceProviderOrganizationDto extends BaseOrganizationDto {
    constructor(fields) {
        super();
        this.type = UserType.SERVICE_PROVIDER;
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(UserType),
    __metadata("design:type", Object)
], ServiceProviderOrganizationDto.prototype, "type", void 0);
export class CreateServiceProviderOrganizationInput extends PickType(ServiceProviderOrganizationDto, ["name"]) {
    constructor() {
        super(...arguments);
        this.type = UserType.SERVICE_PROVIDER;
    }
}
__decorate([
    IsEnum(UserType),
    __metadata("design:type", Object)
], CreateServiceProviderOrganizationInput.prototype, "type", void 0);
export class UpdateServiceProviderOrganizationInput extends PartialType(PickType(ServiceProviderOrganizationDto, ["name"])) {
    constructor() {
        super(...arguments);
        this.type = UserType.SERVICE_PROVIDER;
    }
}
__decorate([
    IsEnum(UserType),
    __metadata("design:type", Object)
], UpdateServiceProviderOrganizationInput.prototype, "type", void 0);
export class UpdateServiceProviderOrganizationDetailsInput extends PartialType(OmitType(ServiceProviderOrganizationDto, ["id", "name", "onChainAddress", "adminEmail"])) {
    constructor(fields) {
        super();
        this.type = UserType.SERVICE_PROVIDER;
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(UserType),
    __metadata("design:type", Object)
], UpdateServiceProviderOrganizationDetailsInput.prototype, "type", void 0);
